import React from 'react';
import PropTypes, { array } from 'prop-types';

import { toThousandSeparator } from 'utils/common';
import { Line } from 'react-chartjs-2';

import './ChartItem.css';

const ChartItem = ({
  chartData,
  type = '',
  color,
  header,
  labelPrefix = '',
  labelPosition,
  compact,
  totalData,
  sum,
  valuePrefix,
  roundValuesTo,
}) => {
  let chartLabels = [];
  let chartValues = [];
  chartLabels = chartData.map(label => label.date);
  chartValues = chartData.map(value => value.value.toFixed(roundValuesTo));

  const data = {
    labels: chartLabels,
    datasets: [
      {
        data: chartValues,
        label: '',
        fill: true,
        lineTension: 0.1,
        backgroundColor: `rgba(${color}, 0.5)`,
        borderColor: `rgba(${color}, 1)`,
        borderCapStyle: 'round',
        pointBorderColor: `rgba(${color}, 1)`,
        pointBackgroundColor: `rgba(${color}, 1)`,
        pointBorderWidth: 1,
        pointHoverRadius: 5,
        pointHoverBackgroundColor: `rgba(${color}, 1)`,
        pointHoverBorderColor: `rgba(${color}, 1)`,
        pointHoverBorderWidth: 2,
        pointRadius: chartData.length > 1 ? 1 : 5,
        pointHitRadius: 20,
      },
    ],
  };

  const options = {
    maintainAspectRatio: compact ? false : true,
    legend: {
      display: false,
    },
    tooltips: {
      yPadding: 10,
      xPadding: 10,
      callbacks: {
        label: () => null,
        title: tooltipItem => (
          `${tooltipItem[0].xLabel} (${labelPosition === 'left' ?
            `${labelPrefix}${toThousandSeparator(tooltipItem[0].yLabel)}`
            :
            `${toThousandSeparator(tooltipItem[0].yLabel)}${labelPrefix}`})`
        ),
      },
    },
    scales: {
      yAxes: [{
        maxBarThickness: 10,
        ticks: {
          padding: 20,
          fontColor: '#8e9aaa',
          callback: (value) => {
            if (value % 1 === 0) { return `${labelPosition === 'left' ? `${labelPrefix}${value}` : `${value}${labelPrefix}`}`; }
            return null;
          },
        },
      }],
      xAxes: [{
        ticks: {
          padding: 20,
          fontColor: '#8e9aaa',
        },
      }],
    },
  };

  return (
    <div className="analytics-activity-chart-item__component">
      <h3>{header}</h3>
      <div className="analytics-activity-chart-item-wrapper">
        <div className="analytics-activity-chart-item-label">
          <div className="wrapper">
            <div className={`icon ${type}`} />
            {sum ?
              <div className="value">
                {labelPosition === 'left' ?
                  <>
                    {labelPrefix}
                    {chartValues && Object.keys(chartValues).length > 0 ? toThousandSeparator(chartValues.reduce((a, b) => Number(a) + Number(b), 0)) : 0}
                  </>
                :
                  <>
                    {chartValues && Object.keys(chartValues).length > 0 ? toThousandSeparator(chartValues.reduce((a, b) => Number(a) + Number(b), 0)) : 0}
                    {labelPrefix}
                  </>
                }
              </div>
              :
              <div className="value">
                {labelPosition === 'left' ?
                  <>
                    {valuePrefix ? valuePrefix : labelPrefix}
                    {totalData && Boolean(totalData) ? toThousandSeparator(totalData) : 0}
                  </>
                :
                  <>
                    {totalData && Boolean(totalData) ? toThousandSeparator(totalData) : 0}
                    {valuePrefix ? valuePrefix : labelPrefix}
                  </>
                }
              </div>
            }
          </div>
        </div>

        <Line data={data} options={options} />
      </div>
    </div>
  );
};

ChartItem.propTypes = {
  chartData: PropTypes.oneOfType([PropTypes.object, PropTypes,array, PropTypes.node]),
  type: PropTypes.string,
  color: PropTypes.string,
  header: PropTypes.string,
  labelPrefix: PropTypes.string,
  labelPosition: PropTypes.string,
  compact: PropTypes.bool,
  totalData: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  sum: PropTypes.bool,
  valuePrefix: PropTypes.string,
  roundValuesTo: PropTypes.number,
};
ChartItem.defaultProps = {
  chartData: null,
  type: '',
  color: null,
  header: null,
  labelPrefix: '',
  labelPosition: 'right',
  compact: false,
  totalData: '',
  sum: false,
  valuePrefix: null,
  roundValuesTo: 0, // pass number of characters after ','
};

export default ChartItem;
